import React from 'react';
import '../../assets/fonts/numerical/fonts.scss';

const FontsNumerical = (): React.ReactElement => {
  return <></>;
};

export default FontsNumerical;
